<template src='./tabHistoric.pug' lang='pug'></template>

<script>
import moment from 'moment'

export default {
  name: 'TabHistoric',

  props: {
    loadHistoric: Function,
    idLancamento: String
  },

  data () {
    return {
      historics: [],
      historicEmpty: false,
      isLoading: false,
      idLastLanc: null
    }
  },

  methods: {
    // Chama a função passada como parâmetro ao clicar na aba pela primeira vez
    clickAction () {
      if (!this.idLastLanc || (this.idLastLanc !== this.idLancamento)) {
        this.isLoading = true
        this.loadHistoric(this.idLancamento).then((response) => {
          this.idLastLanc = this.idLancamento
          this.historics = []
          if (response && response.data && response.data.length > 0) {
            response.data.forEach(data => {
              let history = {
                data: data.data ? moment(data.data).format('LL') : ' - ',
                hora: data.data ? moment(data.data).format('LT') : ' - ',
                id: data.id ? data.id : ' - ',
                status: data.situacaoConciliacao ? data.situacaoConciliacao : ' - ',
                usuario: data.usuarioNome ? data.usuarioNome : ' - ',
                acao: data.acao,
                idLote: data.idConciliacaoLote ? data.idConciliacaoLote : '-'
              }
              this.historics.push(history)
            })
            this.historicEmpty = false
          } else {
            this.historicEmpty = true
          }
          this.isLoading = false
        }).catch((error) => {
          this.$root.$refs.notification.error(error.message)
          this.isLoading = false
        })
      }
    },

    // Verifica se é o primeiro ítem da lista exibido na tela, ou seja, o histórico mais recente, que possui classes css diferentes do restante
    isFirst (index) {
      return !index
    },

    // Retorna a classe responsável pelo css dos dados de acordo com a posição no vetor do histórico
    getClassContent (index) {
      if (index === 0) {
        return 'historic-line-data-first'
      } else if (index === (this.historics.length - 1)) {
        return 'historic-line-data-last'
      }
      return 'historic-line-data'
    },

    // Retorna a label de tradução de acordo com o status retornado pelo MS
    getLabelStatus (key) {
      return key === 'A'
        ? 'statusConciliacao.aberto'
        : key === 'C'
        ? 'statusConciliacao.conciliado'
        : key === 'M'
        ? 'statusConciliacao.conciliadoManualmente'
        : key === 'D'
        ? 'statusConciliacao.divergente'
        : key === 'N'
        ? 'statusConciliacao.naoAplicavel'
        : ' - '
    },

    // Retorna a cor do texto de acordo com o status
    getStyleByStatus (item) {
      let title = ''
      switch (item) {
        case 'C':
          title = 'font-C'
          break
        case 'M':
          title = 'font-C'
          break
        case 'D':
          title = 'font-D'
          break
        case 'N':
          title = 'font-N'
          break
        case 'A':
          title = 'font-A'
          break
        default :
          title = ''
          break
      }
      return title
    },
    // Retorna a key concatenada de acordo com a ação, utilizada para a tradução da ação
    getKeyAction (keyAction) {
      return 'modalDetalhesLanc.tabHistorico.acao.' + keyAction
    }
  }
}
</script>

<style scoped>
#tab-historic-id{
  margin: 0px 0px 10px 1%;
  height: 392px;
  overflow: hidden;
  overflow-y: auto;
  width: 99%;
  font-family: 'Inter', sans-serif;
}

p {
  margin-bottom: 0px;
}

ul > li, ol > li {
  padding: 0px;
}

/*Estilos customizados para o primeiro ítem do histórico (mais recente)*/
ul.historic-line-date-ul-first li {
  font-size: 16px;
  color: #111B54;
  list-style: none;
  margin-top: 15px;
}

ul.historic-line-date-ul-first li:before {
  list-style-type: disc;
  color: #111B54;
  content: "\2022";
  font-size: 57px;
  padding-right: .25em;
  position: relative;
  top: 11px;
}

.historic-line-data-first {
  font-size: 14px;
  color: #FFF;
  border-left: 1px solid #979797;
  margin-left: 12px;
  padding: 20px 0px 30px 20px;
}

.historic-line-data-first:after {
  content: '';
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  background: #efefef;
  border-right:1px solid #cecece;
  border-bottom:1px solid #cecece;
  -moz-transform:rotate(225deg);
  -webkit-transform:rotate(225deg);
  left: calc(75px);
  top: 73px;
}

.historic-line-data-content-first {
  background-color: #efefef;
  padding: 12px 14px;
  color: #252525;
  border-radius: 5px;
  border: 1px solid #cecece;
}

/*Estilos customizados para o restante dos ítens do histórico*/
ul.historic-line-date-ul li {
  font-size: 16px;
  color: #9b9b9b;
  list-style: none;
}

ul.historic-line-date-ul li:before {
  list-style-type: disc;
  color: #9b9b9b;
  content: "\2022";
  font-size: 57px;
  padding-right: .25em;
  position: relative;
  top: 11px;
}

.historic-line-data {
  border-left: 1px solid #979797;
  margin-left: 11px;
  padding: 20px 0px 20px 20px;
  font-size: 14px;
  color: #7C7C7C;
}

.historic-line-data-last {
  margin-left: 12px;
  padding: 20px 0px 20px 20px;
  font-size: 14px;
  color: #7C7C7C;
}

.historic-line-data:after,
.historic-line-data-last:after {
  content: '';
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  background: #FFF;
  border-right:1px solid #e3e3e3;
  border-bottom:1px solid #e3e3e3;
  -moz-transform:rotate(225deg);
  -webkit-transform:rotate(225deg);
  left: calc(75px);
  top: 57px;
}

.historic-line-data-content {
  background-color: #FFF;
  padding: 12px 14px;
  color: #252525;
  border-radius: 5px;
  border: 1px solid #e3e3e3;
}

.historic-line {
  overflow-y: auto;
}

.empty-value {
  text-align: center;
  color: #666;
  font-weight: bold;
  margin-top: 20px;
}

.loadingData {
  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  cursor: wait;
  height: 390px;
  background-size: 100px;
}

.right-text-tabs{
  width: 100%!important;
}

.font-C {
  color: #3bb57a;
}

.font-D {
  color: #f55753;
}

.font-N {
  color: #56a9c1;
}

.font-A {
  color: #fdbd39;
}

.font-default {
  color: #17375f;
}
</style>



// WEBPACK FOOTER //
// TabHistoric.vue?74512a44